import { z } from "zod";

/**
 * Usluga sa više članova (terapija za parove, porodica): `services.maxMembers`
 * uključuje i klijenta koji zakazuje, pa par ima 2, a dodatnih emailova je
 * `maxMembers - 1`. NULL znači obična usluga za jednu osobu. Čist modul jer
 * ga koriste i forma za zakazivanje i server.
 */
export const MEMBERS_MIN = 2;
export const MEMBERS_MAX = 6;

export function maxExtraMembers(maxMembers: number | null | undefined): number {
  return maxMembers ? maxMembers - 1 : 0;
}

export type MemberEmailsResult = { ok: true; emails: string[] } | { ok: false; error: string };

const emailSchema = z.email();

function limitError(n: number): string {
  if (n === 0) return "Ova usluga nema dodatnih članova.";
  if (n === 1) return "Najviše 1 dodatni član.";
  if (n <= 4) return `Najviše ${n} dodatna člana.`;
  return `Najviše ${n} dodatnih članova.`;
}

/** Ista provjera u formi i na serveru: format, duplikati, email platioca, broj. */
export function normalizeMemberEmails(
  raw: string[],
  opts: { maxExtra: number; payerEmail?: string | null },
): MemberEmailsResult {
  const emails = raw.map((e) => e.trim().toLowerCase()).filter((e) => e !== "");
  const payer = opts.payerEmail?.trim().toLowerCase() || null;
  const seen = new Set<string>();
  for (const email of emails) {
    if (!emailSchema.safeParse(email).success) return { ok: false, error: `Neispravan email: ${email}` };
    if (seen.has(email)) return { ok: false, error: `Email ${email} je upisan dvaput.` };
    if (email === payer) return { ok: false, error: `Email ${email} je email klijenta koji zakazuje.` };
    seen.add(email);
  }
  if (emails.length > opts.maxExtra) return { ok: false, error: limitError(opts.maxExtra) };
  return { ok: true, emails };
}
